export default __webpack_public_path__ + "static/media/ic-chapter-test.37cdff99.svg";